/*
 * 项目合同模块接口
 */

import { post, get, put, del } from 'api/http'

export default {
    // 获取项目合同列表信息
    getContractList(data) {
        return get('/app/contract', data)
    },

    // 项目详情信息
    getProjectDetail(data) {
        return get('/app/contract/detail', data)
    },

    // 修改项目在百度地图中的位置
    putProjectLocation(data) {
        return put('/app/contract/location', data)
    },

    // 获取项目详情
    getItemDetail(data) {
        return get('/app/contract/statistic', data)
    },

    // 质安管理详情
    getSafetyMangerDetail(data) {
        return get('/project_detail/safety_manger', data)
    },

    // 添加项目合同简称
    addAbbreviation(data) {
        return put('/app/contract/short_name', data)
    },

    // 详情页公共头部组件-项目信息
    getContractHead(data) {
        // return get('/app/contract/head', data)
        return get('/contract/headDetail', data, 'javaHost')
    },

    // 关注或取消项目合同
    updateContractStared(data) {
        // return put('/app/contract/head', data)
        return post('/contract/editContractAttribute', data, 'javaHost')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/contract.js